import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import VerticalBars from '../../../../../../components/charts/chartjs/vertical-bars/VerticalBars';
import useMessagesAverages from './useMessagesAverages';
import { getChartValueColor } from '../../../../../../utils/chart';
import createTooltipMarkup from '../tooltip-markup/tooltipMarkup';
import VerticalBarTooltipLabels from '../../../../../../components/charts/chartjs/vertical-bars/vertical-bar-tooltip-labels/VerticalBarTooltipLabels';

import scss from './HeadToHeadCharts.module.scss';

function HeadToHeadCharts({ topMessage, selectedMessages }) {
  const { t } = useTranslation('resonance');
  const theme = useSelector((state) => state.global.theme);

  const { r1Average, r2Average } = useMessagesAverages();

  const chartLabels = [
    t('topNumberMessage', { number: 10 }),
    ...selectedMessages.map(({ label }) => label),
    t('average'),
  ];

  const r1Data = [
    topMessage.calculations.r1,
    ...selectedMessages.map(({ calculations }) => calculations.r1),
    r1Average,
  ];

  const r2Data = [
    topMessage.calculations.r2,
    ...selectedMessages.map(({ calculations }) => calculations.r2),
    r2Average,
  ];

  const chartsConfig = {
    options: {
      plugins: {
        legend: {
          display: true,
        },
      },
    },
    tooltip: {
      createMarkup: (tooltipModel, data) => createTooltipMarkup({ tooltipModel, data }),
    },
    datalabels: {
      anchor: 'center',
      align: 'center',
      color: getChartValueColor(theme),
      font: {
        size: '12px',
        weight: 'bold',
        family: 'Inter',
      },
      formatter: function (value) {
        return value ? value + '%' : '';
      },
    },
    scales: {
      x: {
        ticks: {
          display: false,
        },
      },
    },
  };

  return (
    <div className={scss.wrapper}>
      <VerticalBars
        height={'300px'}
        data={{
          labels: chartLabels,
          datasets: [
            {
              label: 'R1',
              data: r1Data,
              backgroundColor: '#519DE9',
              ...DATASET_CONFIG,
            },
            {
              label: 'R2',
              data: r2Data,
              backgroundColor: '#7CC674',
              ...DATASET_CONFIG,
            },
          ],
        }}
        config={chartsConfig}
      />
      <VerticalBarTooltipLabels labels={chartLabels} />
    </div>
  );
}

export default HeadToHeadCharts;

const DATASET_CONFIG = {
  borderWidth: 0,
  borderRadius: 8,
};
